import Checkpoint from "../../../../../components/categories/superadmin/master_data/checkpoint/Home"

export default function Home() {  
  return (
    <Checkpoint />
  );
}
